import { render, staticRenderFns } from "./ModalSubitemEdit.vue?vue&type=template&id=b3317890&"
import script from "./ModalSubitemEdit.vue?vue&type=script&lang=js&"
export * from "./ModalSubitemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports